import React, { useRef, useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  IconButton,
  FormControlLabel,
  Checkbox,
  Typography,
  Button,
  TextField,
} from "@mui/material";
import { CustomButton } from "./CustomButton";
import { useTranslation } from "react-i18next";
import logoAn from "../assets/LogoAn.png";
import AppBar from "@mui/material/AppBar";
import Logo from "../assets/Logo.png";
import { connect } from "react-redux";
import { styles } from "../theme/styles";
import Swal from "sweetalert2";
import SignatureCanvas from "react-signature-canvas";
import axios from "axios";
import { ClipLoader } from "react-spinners";
import { DatosCompradorContext } from "../context/Context";
import { Creators } from "../store/ducks/users";
import { Creators as CreatorsConfig } from "../store/ducks/config";
import { decodedData } from "../helpers/encode";
import Cookies from "js-cookie";
const PdfView2 = (props) => {
  const {
    correoCompradorContext,
    setCorreoCompradorContext,
    tiendaAsociadaContext,
    setTiendaAsociadaContext,
    rolContext,
    setRolContext,
    idGeneradoContext,
    setIdGeneradoContext,
    idbuscadoContext,
    setIdbuscadoContext,
    resetData,
    skuContext,
    setSkucontext,
  } = useContext(DatosCompradorContext);
  const { userData } = props;
  const idBuscadoAux = decodedData("IDBUSCADO");
  const valorPdf = `${process.env.REACT_APP_BACK_APIVENTAANIMALES}/imagenes/getArchivo2Dir/NotaVenta${idBuscadoAux}.pdf`; //folio de nota venta
  const [auxSpinner, setAuxSpinner] = React.useState(true);
  const navigate = useNavigate();
  const [reloadIframe, setReloadIframe] = useState(true);
  const [iframeOffSetTop, setIframeOffSetTop] = useState(0);
  const [iframeOffSetRight, setIframeOffSetRight] = useState(0);
  const [emailCompradorAux, setEmailCompradorAux] = useState("");
  const [mostrarSpinner, setMostrarSpinner] = useState(false);
  const [hayErrCorreo, setHayErrCorreo] = useState(false);
  const [enableEdit, setEnableEdit] = useState(false);

  const swalEdit = () => {
    Swal.fire({
      title: "¿Deseas editar el correo?",
      text: "Recuerda que los correos solo pueden ser reenviados a correos registrados en Petco.",
      icon: "info",
      confirmButtonText: "Aceptar",
      confirmButtonColor: "#00205B",
      cancelButtonText: "Cancelar",
      showCancelButton: true,
      // iconColor: "green",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        setEnableEdit(true);
      } else {
        setEnableEdit(false);
      }
    });
  };

  const formatoFolio = (folio) => {
    return folio.replace(/([a-zA-Z])([0-9]+)/g, "$1_$2");
  };
  const targetRef = useRef();
  function adjustZoom() {
    const windowWidth = window.innerWidth;
    let zoom;
    if (windowWidth > 768) {
      zoom = 100; // Zoom para pantallas pequeñas
    } else if (windowWidth > 400 && windowWidth > 768) {
      zoom = 70; // Zoom para pantallas medianas
    } else if (windowWidth > 400) {
      zoom = 40; // Zoom para pantallas grandes
    }
  }

  const enviarCorreo = async (bodySendEmail) => {
    try {
      const respSendEmail = await axios.post(
        `${process.env.REACT_APP_BACK_APIVENTAANIMALES}/imagenes/enviarPDFporCorreo`,
        bodySendEmail,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_AUTHPETCOMPLETE}`,
            apikey: `${process.env.REACT_APP_APIKEYPETCOMPLETE}`,
            "Content-Type": "application/json",
          },
        }
      );
    } catch (error) {
      throw error;
      console.log("Ocurrio un error al enviar el correo", error);
    }
  };
  const getInfoFolioAux = async () => {
    try {
      const info = await axios.get(
        `${
          process.env.REACT_APP_BACK_APIVENTAANIMALES
        }/ventas/getInfoRegistro/${formatoFolio(idBuscadoAux)}`
      );
      setEmailCompradorAux(info.data.info.emailComprador);
      // const respCorreo = await enviarCorreo();
    } catch (error) {
      console.log("ocurrio un error", error);
    }
  };
  const getInfoFolio = async () => {
    setAuxSpinner(true);
    try {
      const info = await axios.get(
        `${
          process.env.REACT_APP_BACK_APIVENTAANIMALES
        }/ventas/getInfoRegistro/${formatoFolio(idBuscadoAux)}`
      );
      // console.log("infoFolio: ", info.data);
      // console.log("userData: ", userData);
      const bodyData = {
        correoComprador: emailCompradorAux,
        idG: idBuscadoAux,
        idVendedor: userData.idNumber,
        sku: formatoFolio(info.data.info.sku),
      };
      try {
        const respCorreo = await enviarCorreo(bodyData);
        Swal.fire({
          title: "Nota enviada correctamente.",
          icon: "success",
          confirmButtonText: "Regresar",
          confirmButtonColor: "#00205B",
          iconColor: "green",
          allowOutsideClick: false,
        });
      } catch (error) {
        Swal.fire({
          title: "Nota no enviada.",
          html: `Por favor, verifica que el correo <b>${emailCompradorAux}</b> se encuentre registrado en petco.`,
          icon: "warning",
          confirmButtonText: "Regresar",
          confirmButtonColor: "#00205B",
          iconColor: "red",
          allowOutsideClick: false,
        });
      }

      // console.log("respCorreo: ", respCorreo);
      setAuxSpinner(false);
    } catch (error) {
      console.log("ocurrio un error", error);
    }
  };
  const showPdf = () => {
    setTimeout(() => {
      setAuxSpinner(false);
    }, 1000);
  };
  const navegar = (direccion) => {
    navigate(`/buscadorContratos`);
    Cookies.remove("IDBUSCADO");
  };
  useEffect(() => {
    showPdf();
    const iframe = document.querySelector("iframe");
    if (iframe) {
      setIframeOffSetTop(iframe.offsetTop);
      setIframeOffSetRight(iframe.offsetLeft);
    }
    getInfoFolioAux();
  }, []);

  return (
    <>
      <div
        style={{
          height: "85vh",
          overflow: "-moz-hidden-unscrollable",
          justifyContent: "center",
          alignContent: "center",
        }}>
        <Grid style={styles.divPdf}>
          <IconButton style={styles.btnBack} onClick={navegar}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="icon icon-tabler icon-tabler-arrow-back"
              width="36"
              height="36"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="#00205b"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M9 11l-4 4l4 4m-4 -4h11a4 4 0 0 0 0 -8h-1" />
            </svg>
          </IconButton>
          <div
            style={{
              display: "flex",
              gap: "1rem",
              width: "auto",
              justifyContent: "center",
              alignItems: "center",
            }}>
            {/* <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#00205b"
              stroke-linecap="round"
              stroke-linejoin="round"
              width="36"
              height="36"
              stroke-width="2"
              onClick={swalEdit}>
              {" "}
              <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1"></path>{" "}
              <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z"></path>{" "}
              <path d="M16 5l3 3"></path>{" "}
            </svg> */}
            {/* <TextField
              label={hayErrCorreo ? "obligatorio" : ""}
              error={hayErrCorreo}
              style={{ minWidth: "10vw" }}
              value={emailCompradorAux}
              onChange={(e) => {
                setEmailCompradorAux(e.target.value);
                setHayErrCorreo(false);
              }}
              disabled={!enableEdit}></TextField> */}
            {/* <input
            type="text"
            value={emailCompradorAux}
            onChange={(e) => setEmailCompradorAux(e.target.value)}></input>{" "} */}
            {/* <CustomButton
              style={{ width: "auto" }}
              onClick={async () => {
                setEnableEdit(false);
                if (emailCompradorAux) await getInfoFolio();
                else {
                  // alert("xdxd");
                  setHayErrCorreo(true);
                }
              }}>
              Reenviar nota
            </CustomButton> */}
            {/* <Button
              onClick={async () => {
                await getInfoFolio();
              }}
            >
              Reenviar nota
            </Button> */}
          </div>

          {/* Muestreo pdf */}
          <iframe
            style={styles.pdfViewer2}
            src={valorPdf}
            frameBorder="0"
            scrolling="no"
            key={reloadIframe}
          />
          {auxSpinner && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 9999,
                backgroundColor: "rgba(255, 255, 255, 0.8)",
                gap: "2rem",
              }}>
              {" "}
              <ClipLoader color="#00205B" size="100px"></ClipLoader>
              <p>Cargando.</p>
            </div>
          )}

          {/* {auxSpinner == false ? (
            <>
              <iframe
                style={styles.pdfViewer2}
                src={valorPdf}
                frameBorder="0"
                scrolling="no"
                key={reloadIframe}
              />
            </>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 9999,
                backgroundColor: "rgba(255, 255, 255, 0.8)",
                gap: "2rem",
              }}
            >
              {" "}
              <ClipLoader color="#00205B" size="100px"></ClipLoader>
              <p>Cargando.</p>
            </div>
          )} */}

          {/* {auxSpinner == false ? (
            <>
              <iframe
                style={styles.pdfViewer2}
                src={valorPdf}
                frameBorder="0"
                scrolling="no"
                key={reloadIframe}
              />
            </>
          ) : (
            <ClipLoader color="#00205B" size="100px"></ClipLoader>
          )} */}
          <div ref={targetRef}></div>
        </Grid>
      </div>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    menu: state.users.menu,
    userData: state.users.data,
    message: state.config.message,
    redirectToPasswordScreen: state.users.redirectToPasswordScreen,
  };
};
const creators = {
  logout: Creators.logout,
  clearMessage: CreatorsConfig.clearMessage,
};

// export default PdfView2;
export default connect(mapStateToProps, creators)(PdfView2);
